import Page, {PageProps} from 'components/Page';
import {Footer} from './Footer';
import {AllianzPageWrapper} from './styled';

const defaultProps: PageProps = {
  children: '',
  title: '',
  isSubHeaderVisible: false,
  isLoading: false,
  isBackButtonDisabled: false,
  hideMenu: false,
};

function AllianzPage(props: PageProps) {
  return (
    <AllianzPageWrapper>
      <Page {...props}>
        <>{props.children}</>
      </Page>
      <Footer />
    </AllianzPageWrapper>
  );
}

Page.defaultProps = defaultProps;

export {AllianzPage};
